import { render, staticRenderFns } from "./IconEdit.vue?vue&type=template&id=e3dbb6b4&scoped=true&"
var script = {}
import style0 from "./IconEdit.vue?vue&type=style&index=0&id=e3dbb6b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3dbb6b4",
  null
  
)

export default component.exports